import React from 'react'

import Dropzone from 'react-dropzone'

import {
  Icon,
  ImageAdd,
  Button,
  Spinner,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

function ImageSearchIcon() {
  return <ImageAdd width="32" height="32" />
}

function DropdownIcon({ isLoading }) {
  if (isLoading) {
    return <Spinner size="small" />
  }

  return (
    <Icon
      color="dark"
      notSpaced
      size="medium"
      svgComponent={ImageSearchIcon}
      className="wayfinder__action-icon-svg"
    />
  )
}

function ImageSearchDropdown({
  isLoading,
  handleFileDrop,
  locale = 'en',
}) {
  const buttonText = i18n.t('navigation.search.buttonText', { ns: 'rails', lng: locale })
  const uploadingText = i18n.t('navigation.search.uploading', { ns: 'rails', lng: locale })
  const dragAndDropText = i18n.t('navigation.search.dragAndDrop', { ns: 'rails', lng: locale })
  const immediatelyAfterUploadText = i18n.t('navigation.search.immediatelyAfterUpload', { ns: 'rails', lng: locale })
  const formatsText = i18n.t('navigation.search.formats', { ns: 'rails', lng: locale })

  return (
    <Dropzone
      className="drop-area"
      multiple={false}
      maxSize={26214400} // 25mb
      accept=".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp"
      onDrop={handleFileDrop}
    >
      <div className="image-search">

        <DropdownIcon isLoading={isLoading} />

        {isLoading ? (
          <p className="ct-mb-0 image-search__title">{uploadingText}</p>
        ) : (
          <div className="image-search__row">
            <p className="cgt-mb-0 image-search__title">{dragAndDropText}</p>
            <Button actionType="button">{buttonText}</Button>
          </div>
        )}

        {isLoading ? (
          <p className="cgt-legacy-text-tiny cgt-legacy-text--align-center image-search__subtitle">
            {immediatelyAfterUploadText}
          </p>
        ) : (
          <p className="cgt-legacy-text-tiny cgt-legacy-text--align-center image-search__subtitle">
            {formatsText}
          </p>
        )}
      </div>
    </Dropzone>
  )
}

DropdownIcon.propTypes = {
  isLoading: bool.isRequired,
}

ImageSearchDropdown.propTypes = {
  isLoading: bool.isRequired,
  handleFileDrop: func.isRequired,
  locale: string,
}

export default ImageSearchDropdown
